
import { mixins, Options } from "vue-class-component";
import { RoutingUtilityMixin } from "@/mixins";
import { hasAccessToPinnedAssets } from "@/utils/assetAccessChecker";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";

const PINNED_ASSETS_ROUTE = "3d-viewer/pinnedAssets";

@Options({
  name: "AlbumsButton",
  components: {
    SvgIcon,
  },
})
export default class AlbumsButton extends mixins(RoutingUtilityMixin) {
  protected get isMyAssetsRoute(): boolean {
    return this.$route.name == PINNED_ASSETS_ROUTE;
  }

  protected get hasAccessToPinnedAssets(): boolean {
    return hasAccessToPinnedAssets();
  }

  protected get toPinnedAssets(): string {
    return this.constructLocaleAwarePath("/my-assets");
  }
}
